import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { getTeamMemberLastSelectedStateDataByTeamMemberId } from '../teamMemberLastSelectedStates/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getTeamMemberListData,
  getTeamMemberOverviewDataById,
  getTeamMemberDataById,
} from './mockData'
import type {
  ITeamMember,
  ITeamMemberLastSelectedState,
} from '@/types/teamMember/models'

interface GetTeamMembersResponse {
  data: ITeamMember[] | undefined
}

async function getTeamMembers(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning team members.`)
  const responseBody: GetTeamMembersResponse = {
    data: await getTeamMemberListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getTeamMember_byId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed teamMember id is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody = { data: await getTeamMemberDataById(id) }
  console.log(`'Returning data for team member "${id}".`)
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getTeamMemberOverview_byId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed teamMember id is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody = { data: await getTeamMemberOverviewDataById(id) }
  console.log(`'Returning overview for team member "${id}".`)
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetTeamMemberLastSelectedStateResponse {
  data: ITeamMemberLastSelectedState
}

async function getTeamMemberLastSelectedStateById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetTeamMemberLastSelectedStateResponse = {
      data: await getTeamMemberLastSelectedStateDataByTeamMemberId(id)!, // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get TeamMember ${id} last selected data: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getTeamMemberListData)
}

const patchTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getTeamMemberListData)
}

const deleteTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTeamMemberListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/teammembers',
    handler: getTeamMembers,
  },
  {
    method: 'get',
    path: '/api/teammembers/:id',
    handler: getTeamMember_byId,
  },
  {
    method: 'get',
    path: '/api/teammembers/:id/overview',
    handler: getTeamMemberOverview_byId,
  },
  {
    method: 'get',
    path: '/api/teammembers/:id/lastselectedstate',
    handler: getTeamMemberLastSelectedStateById,
  },
  {
    method: 'post',
    path: '/api/teammembers',
    handler: postTeamMember,
  },
  {
    method: 'patch',
    path: '/api/teammembers/:id',
    handler: patchTeamMember,
  },
  {
    method: 'delete',
    path: '/api/teammembers/:id',
    handler: deleteTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
